import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Plus } from '@phosphor-icons/react';
import { Button, Input, Modal, Table } from 'app/components';
import { ACTION_ITEMS, COLUMN_CONFIG } from './constants';
import { createCity, deleteCity, getCityList } from './api';

const AdminCityList = () => {
  const [venueConfig, setVenueConfig] = useState(null);
  const [deletableVenueId, setDeletableVenueId] = useState(null);

  const { cityList } = useSelector((state) => state.adminCityList);

  useEffect(() => {
    getCityList();
  }, []);

  const closeModal = () => setVenueConfig(null);

  const saveVenueDetails = (venue, cb) => {
    createCity(venue, cb);
  };

  const onAddVenue = (venue) => {
    saveVenueDetails(venue, () => {
      getCityList();
      closeModal();
    });
  };

  const HeaderActionItems = (
    <Button
      size="small"
      className="ml-12"
      onClick={() => setVenueConfig({})}
      iconLeft={<Plus />}
    >
        Add New City
    </Button>
  );

  const onClickActionItem = (actionItem, row) => {
    if (actionItem.action === 'delete') {
      setDeletableVenueId(row?._id);
    }
  };

  const onDeleteVenue = () => {
    deleteCity(deletableVenueId, () => {
      getCityList();
      setDeletableVenueId(null);
    });
  };

  return (
    <div className="flex flex-col gap-4 p-5 admin-events-list">
      <Table
        className="venue-list-table"
        columns={COLUMN_CONFIG}
        rows={cityList}
        hasPagination={false}
        showSearch={false}
        headerActionItems={HeaderActionItems}
        actionItems={ACTION_ITEMS}
        onClickActionItem={onClickActionItem}
      />
      {!!venueConfig && (
        <Modal
          className="add-city-modal"
          primaryText="Add"
          size="regular"
          isOpen={!!venueConfig}
          onClickPrimaryCta={() => onAddVenue(venueConfig)}
          onClickSecondaryCta={closeModal}
          title="Add City"
        >
          <Input
            value={venueConfig?.cityName || ''}
            onChange={(e) => setVenueConfig({ cityName: e?.target?.value })}
            placeholder="Enter City Name"
            className="w-full"
          />
        </Modal>
      )}
      <Modal
        className="delete-confirmation-modal"
        primaryText="Delete"
        size="regular"
        isOpen={!!deletableVenueId}
        onClickPrimaryCta={onDeleteVenue}
        onClickSecondaryCta={() => setDeletableVenueId(null)}
        title="Are you sure you want to delete this city?"
      />
    </div>
  );
};

export default AdminCityList;
